export const testimonials = [
  {
    id: 1,
    name: '陈工',
    role: '高级前端工程师',
    company: '某互联网大厂',
    content: '草榴社区技术讨论区是我每天必逛的技术社区。这里的文章质量非常高，尤其是前端开发相关的深度讨论，帮助我解决了很多实际工作中遇到的技术难题。强烈推荐给每一位技术人！',
    avatar: 'https://readdy.ai/api/search-image?query=Chinese%20male%20professional%20headshot%20portrait%20with%20simple%20light%20background%2C%20clean%20minimalist%20style%2C%20business%20attire%2C%20warm%20natural%20lighting&width=80&height=80&seq=testimonial-1&orientation=squarish',
  },
  {
    id: 2,
    name: '林姐',
    role: '安全研究员',
    company: '知名安全公司',
    content: '网络安全板块的内容非常有深度，很多漏洞分析文章都来自一线安全研究人员的实战经验。在这里不仅能学到新技术，还能结识很多行业内的优秀同行。',
    avatar: 'https://readdy.ai/api/search-image?query=Chinese%20female%20professional%20headshot%20portrait%20with%20simple%20light%20background%2C%20clean%20minimalist%20style%2C%20business%20casual%20attire%2C%20warm%20natural%20lighting&width=80&height=80&seq=testimonial-2&orientation=squarish',
  },
  {
    id: 3,
    name: '小刘',
    role: 'AI 算法工程师',
    company: 'AI 创业公司',
    content: '作为一个刚入行的 AI 新人，我在草榴社区学到了太多东西。从基础的机器学习理论到最新的 LLM 应用实践，社区的前辈们都非常乐于分享和指导。真心感谢这个平台！',
    avatar: 'https://readdy.ai/api/search-image?query=Chinese%20male%20young%20professional%20headshot%20portrait%20with%20simple%20light%20background%2C%20clean%20minimalist%20style%2C%20casual%20attire%2C%20warm%20natural%20lighting&width=80&height=80&seq=testimonial-3&orientation=squarish',
  },
  {
    id: 4,
    name: '大周',
    role: 'DevOps 架构师',
    company: '云计算平台',
    content: '运维架构板块的讨论质量远超我的预期。很多关于 Kubernetes 和云原生的实战文章，直接帮我优化了公司的集群架构方案。社区的讨论氛围也非常好，是我见过最纯粹的技术社区。',
    avatar: 'https://readdy.ai/api/search-image?query=Chinese%20male%20professional%20headshot%20portrait%20with%20simple%20light%20background%2C%20clean%20minimalist%20style%2C%20tech%20casual%20attire%2C%20warm%20natural%20lighting&width=80&height=80&seq=testimonial-4&orientation=squarish',
  },
];